import React from "react";

import { formatDateString, phoneNumberFormat } from "../../utils/format";
import { renderArchived, renderBusinessName } from "../../utils/actions";

import { ClientsPage } from "./ClientsPage";

export class FinishApplication extends React.Component {
  render() {
    const columnsSet = [
      {
        data: "id",
        visible: false,
        searchable: false,
        targets: [0],
      },
      {
        data: "archived",
        title: "Archive",
        width: "50px",
        autowidth: false,
        targets: [1],
        orderable: false,
        render: renderArchived,
      },
      {
        data: "businessName",
        width: "auto",
        autowidth: true,
        title: "Client",
        targets: [2],
        defaultContent: "",
        className: "",
        render: renderBusinessName,
      },
      {
        data: "clientId",
        title: "Client ID",
        width: "70px",
        autowidth: false,
        targets: [3],
      },
      {
        data: "primaryContactPhone",
        title: "Phone",
        width: "100px",
        autowidth: false,
        targets: [4],
        render: phoneNumberFormat,
      },
      {
        data: "busClass",
        title: "Business Classification",
        width: "110px",
        autowidth: false,
        targets: [5],
      },
      {
        data: "uaClientCreatedOn",
        title: "App Started",
        width: "80px",
        autowidth: false,
        targets: [6],
        render: formatDateString,
      },
      {
        data: "endTableBtn",
        title: "",
        targets: [7],
        sortable: false,
        className: "btn-column w-100",
      },
    ];

    return (
      <div>
        <ClientsPage
          columns={columnsSet}
          order={[[6, "desc"]]}
          pageHeader="Finish Quote"
          clientTypes={[
            { name: "All Clients", value: "BoundPolicies" },
            {
              name: "Started within past 30 days",
              value: "StartedWithinPast30Days",
            },
            {
              name: "Started within past 60 days",
              value: "StartedWithinPast60Days",
            },
            {
              name: "Started within past 90 days",
              value: "StartedWithinPast90Days",
            },
          ]}
          clientType="BoundPolicies"
          unsubmittedClients={true}
          statisticItems={[
            {
              name: "Clients",
              value: 0,
              icon: "client-counter.svg",
            },
          ]}
          getUpdatedStatisticsCallback={(data) => {
            var statiscticsItems = [];

            statiscticsItems.push({
              name: "Clients",
              value: data.recordsTotal,
              icon: "client-counter.svg",
            });

            return statiscticsItems;
          }}
        />
      </div>
    );
  }
}
